import React from 'react'
import { createRoot } from 'react-dom/client'
import Group from '../components/group'
import GroupForm from '../components/group-form'
import WarningModal from '../components/warning-modal'
import { ApolloProvider, useQuery } from '@apollo/client'
import client from '../client'
import fetchGroups from '../queries/group-list'

function GroupList({ role, currentUserId }) {
  const [warningMsg, setWarningMsg] = React.useState(false)
  const [warningAction, setWarningAction] = React.useState(null)
  const [activeTab, setActiveTab] = React.useState('my-groups')
  const [showNewGroupForm, setshowNewGroupForm] = React.useState(false)

  const { error, loading, data } = useQuery(fetchGroups)

  if (loading) return <div>Loading...</div>
  if (error) return <div>Error :(</div>

  const setWarning = (warningMsg, warningAction) => {
    setWarningMsg(warningMsg)
    setWarningAction(() => warningAction)
  }

  const dismissWarning = (e) => {
    e.preventDefault()

    setWarningMsg(null)
  }

  const showTab = (tabName) => {
    setActiveTab(tabName)
  }

  const toggleNewGroupForm = () => {
    setshowNewGroupForm(!showNewGroupForm)
  }

  const renderShowNewGroupForm = () => {
    if (showNewGroupForm) {
      return (
        <div className="group-card new" onClick={toggleNewGroupForm}>
          <i className="material-icons">add_circle</i>
          <GroupForm isActive={showNewGroupForm} dismiss={toggleNewGroupForm} />
        </div>
      )
    }
  }

  const renderTabControl = (tabName, tabDisplayName) => {
    let className = ''

    if (activeTab === tabName) {
      className = 'active'
    }

    return (
      <a className={className} onClick={() => showTab(tabName)}>
        {tabDisplayName}
      </a>
    )
  }

  const renderGroupTab = () => {
    let className = ''

    if (activeTab === 'shared-groups') {
      className = 'active'
    }

    const tabDisplayName =
      role === 'Teacher' ? 'Other Groups' : 'Groups by instructors'

    return (
      <a className={className} onClick={() => showTab('shared-groups')}>
        {tabDisplayName}
      </a>
    )
  }

  const combineArchivedGroups = (ownedGroups, otherGroups) => {
    let other = otherGroups && otherGroups.filter((g) => g.archived)
    let owned = ownedGroups && ownedGroups.filter((g) => g.archived)
    return owned && owned.concat(other)
  }

  const activeOwnedGroups =
    data.ownedGroups && data.ownedGroups.filter((g) => !g.archived)
  const activeOtherGroups =
    data.otherGroups && data.otherGroups.filter((g) => !g.archived)
  const archivedGroups = combineArchivedGroups(
    data.ownedGroups,
    data.otherGroups
  )

  return (
    <div>
      <div className="header container">
        <h1>Groups</h1>
        {activeTab === 'my-groups' && (
          <nav className="actions">
            <a onClick={toggleNewGroupForm} className="button">
              New Group
            </a>
          </nav>
        )}
      </div>
      <nav className="tabbed-subnav" role="navigation">
        <div className="container">
          {renderTabControl('my-groups', 'My Groups')}
          {renderGroupTab()}
          {renderTabControl('archived-groups', 'Archived')}
        </div>
      </nav>
      <div className="group-list container">
        {activeTab === 'my-groups' && (
          <div className="group-list-section my-groups">
            {renderShowNewGroupForm()}
            {activeOwnedGroups &&
              activeOwnedGroups.map((g) => (
                <Group
                  data={g}
                  owned
                  currentUserId={currentUserId}
                  setWarning={setWarning}
                />
              ))}
          </div>
        )}
        {activeTab === 'shared-groups' && (
          <div className="group-list-section shared-groups">
            {renderShowNewGroupForm()}
            {activeOtherGroups &&
              activeOtherGroups.map((g) => (
                <Group
                  data={g}
                  currentUserId={currentUserId}
                  setWarning={setWarning}
                  role={role}
                />
              ))}
          </div>
        )}
        {activeTab === 'archived-groups' && (
          <div className="group-list-section archived-groups">
            {renderShowNewGroupForm()}
            {archivedGroups &&
              archivedGroups.map((g) => (
                <Group
                  data={g}
                  owned
                  currentUserId={currentUserId}
                  archived
                  setWarning={setWarning}
                  role={role}
                />
              ))}
          </div>
        )}
        <WarningModal
          dismissText="No"
          isOpen={warningMsg}
          onClose={dismissWarning}
          onConfirm={warningAction}
        >
          <h2
            style={{ marginTop: 48, marginBottom: 54 }}
            dangerouslySetInnerHTML={{ __html: warningMsg }}
          />
        </WarningModal>
      </div>
    </div>
  )
}

const groupsList = document.getElementById('groups-list')
if (groupsList) {
  const role = groupsList.dataset.role
  const currentUserId = groupsList.dataset.id

  const root = createRoot(groupsList)
  root.render(
    <ApolloProvider client={client}>
      <GroupList role={role} currentUserId={currentUserId} />
    </ApolloProvider>
  )
}
